import SideMenuItems from './SideMenuItems';

export default SideMenuItems;
